import { render, staticRenderFns } from "./DuwaBookings.vue?vue&type=template&id=e98ecc22"
import script from "./DuwaBookings.vue?vue&type=script&lang=js"
export * from "./DuwaBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports